// source: proto/feepb/feeclearingmarginint.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var proto_utilspb_pagination_pb = require('../../proto/utilspb/pagination_pb.js');
goog.object.extend(proto, proto_utilspb_pagination_pb);
goog.exportSymbol('proto.feepb.ClearingFeeDetails', null, global);
goog.exportSymbol('proto.feepb.ClearingMarginInt', null, global);
goog.exportSymbol('proto.feepb.ListClearingFeeDetailsRequest', null, global);
goog.exportSymbol('proto.feepb.ListClearingFeeDetailsResponse', null, global);
goog.exportSymbol('proto.feepb.ListClearingMarginIntRequest', null, global);
goog.exportSymbol('proto.feepb.ListClearingMarginIntResponse', null, global);
goog.exportSymbol('proto.feepb.ListClearingMarginIntSummary', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.feepb.ClearingMarginInt = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.feepb.ClearingMarginInt, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.feepb.ClearingMarginInt.displayName = 'proto.feepb.ClearingMarginInt';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.feepb.ListClearingMarginIntRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.feepb.ListClearingMarginIntRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.feepb.ListClearingMarginIntRequest.displayName = 'proto.feepb.ListClearingMarginIntRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.feepb.ListClearingMarginIntResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.feepb.ListClearingMarginIntResponse.repeatedFields_, null);
};
goog.inherits(proto.feepb.ListClearingMarginIntResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.feepb.ListClearingMarginIntResponse.displayName = 'proto.feepb.ListClearingMarginIntResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.feepb.ListClearingMarginIntSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.feepb.ListClearingMarginIntSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.feepb.ListClearingMarginIntSummary.displayName = 'proto.feepb.ListClearingMarginIntSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.feepb.ClearingFeeDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.feepb.ClearingFeeDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.feepb.ClearingFeeDetails.displayName = 'proto.feepb.ClearingFeeDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.feepb.ListClearingFeeDetailsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.feepb.ListClearingFeeDetailsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.feepb.ListClearingFeeDetailsRequest.displayName = 'proto.feepb.ListClearingFeeDetailsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.feepb.ListClearingFeeDetailsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.feepb.ListClearingFeeDetailsResponse.repeatedFields_, null);
};
goog.inherits(proto.feepb.ListClearingFeeDetailsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.feepb.ListClearingFeeDetailsResponse.displayName = 'proto.feepb.ListClearingFeeDetailsResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.feepb.ClearingMarginInt.prototype.toObject = function(opt_includeInstance) {
  return proto.feepb.ClearingMarginInt.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.feepb.ClearingMarginInt} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.feepb.ClearingMarginInt.toObject = function(includeInstance, msg) {
  var f, obj = {
    correspondent: jspb.Message.getFieldWithDefault(msg, 1, ""),
    branch: jspb.Message.getFieldWithDefault(msg, 2, ""),
    rep: jspb.Message.getFieldWithDefault(msg, 3, ""),
    masterAccountNo: jspb.Message.getFieldWithDefault(msg, 4, ""),
    month: jspb.Message.getFieldWithDefault(msg, 5, ""),
    year: jspb.Message.getFieldWithDefault(msg, 6, ""),
    recurringFee: jspb.Message.getFieldWithDefault(msg, 7, ""),
    qty: jspb.Message.getFieldWithDefault(msg, 8, ""),
    grossAmt: jspb.Message.getFieldWithDefault(msg, 9, ""),
    chargeBy: jspb.Message.getFieldWithDefault(msg, 10, ""),
    minCharge: jspb.Message.getFieldWithDefault(msg, 11, ""),
    rate: jspb.Message.getFieldWithDefault(msg, 12, ""),
    totalCharge: jspb.Message.getFieldWithDefault(msg, 13, ""),
    feeType: jspb.Message.getFieldWithDefault(msg, 14, ""),
    reportId: jspb.Message.getFieldWithDefault(msg, 15, 0),
    status: jspb.Message.getFieldWithDefault(msg, 16, ""),
    accountNo: jspb.Message.getFieldWithDefault(msg, 17, ""),
    contraAccountNo: jspb.Message.getFieldWithDefault(msg, 18, ""),
    contraCorrespondent: jspb.Message.getFieldWithDefault(msg, 19, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.feepb.ClearingMarginInt}
 */
proto.feepb.ClearingMarginInt.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.feepb.ClearingMarginInt;
  return proto.feepb.ClearingMarginInt.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.feepb.ClearingMarginInt} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.feepb.ClearingMarginInt}
 */
proto.feepb.ClearingMarginInt.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrespondent(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBranch(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRep(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccountNo(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMonth(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setYear(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecurringFee(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setQty(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setGrossAmt(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setChargeBy(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setMinCharge(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setRate(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalCharge(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setFeeType(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setReportId(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNo(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setContraAccountNo(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setContraCorrespondent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.feepb.ClearingMarginInt.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.feepb.ClearingMarginInt.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.feepb.ClearingMarginInt} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.feepb.ClearingMarginInt.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBranch();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRep();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMonth();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getYear();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getRecurringFee();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getQty();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getGrossAmt();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getChargeBy();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getMinCharge();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getRate();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getTotalCharge();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getFeeType();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getReportId();
  if (f !== 0) {
    writer.writeUint32(
      15,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getContraAccountNo();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getContraCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
};


/**
 * optional string correspondent = 1;
 * @return {string}
 */
proto.feepb.ClearingMarginInt.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingMarginInt} returns this
 */
proto.feepb.ClearingMarginInt.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string branch = 2;
 * @return {string}
 */
proto.feepb.ClearingMarginInt.prototype.getBranch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingMarginInt} returns this
 */
proto.feepb.ClearingMarginInt.prototype.setBranch = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string rep = 3;
 * @return {string}
 */
proto.feepb.ClearingMarginInt.prototype.getRep = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingMarginInt} returns this
 */
proto.feepb.ClearingMarginInt.prototype.setRep = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string master_account_no = 4;
 * @return {string}
 */
proto.feepb.ClearingMarginInt.prototype.getMasterAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingMarginInt} returns this
 */
proto.feepb.ClearingMarginInt.prototype.setMasterAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string month = 5;
 * @return {string}
 */
proto.feepb.ClearingMarginInt.prototype.getMonth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingMarginInt} returns this
 */
proto.feepb.ClearingMarginInt.prototype.setMonth = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string year = 6;
 * @return {string}
 */
proto.feepb.ClearingMarginInt.prototype.getYear = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingMarginInt} returns this
 */
proto.feepb.ClearingMarginInt.prototype.setYear = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string recurring_fee = 7;
 * @return {string}
 */
proto.feepb.ClearingMarginInt.prototype.getRecurringFee = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingMarginInt} returns this
 */
proto.feepb.ClearingMarginInt.prototype.setRecurringFee = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string qty = 8;
 * @return {string}
 */
proto.feepb.ClearingMarginInt.prototype.getQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingMarginInt} returns this
 */
proto.feepb.ClearingMarginInt.prototype.setQty = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string gross_amt = 9;
 * @return {string}
 */
proto.feepb.ClearingMarginInt.prototype.getGrossAmt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingMarginInt} returns this
 */
proto.feepb.ClearingMarginInt.prototype.setGrossAmt = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string charge_by = 10;
 * @return {string}
 */
proto.feepb.ClearingMarginInt.prototype.getChargeBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingMarginInt} returns this
 */
proto.feepb.ClearingMarginInt.prototype.setChargeBy = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string min_charge = 11;
 * @return {string}
 */
proto.feepb.ClearingMarginInt.prototype.getMinCharge = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingMarginInt} returns this
 */
proto.feepb.ClearingMarginInt.prototype.setMinCharge = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string rate = 12;
 * @return {string}
 */
proto.feepb.ClearingMarginInt.prototype.getRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingMarginInt} returns this
 */
proto.feepb.ClearingMarginInt.prototype.setRate = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string total_charge = 13;
 * @return {string}
 */
proto.feepb.ClearingMarginInt.prototype.getTotalCharge = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingMarginInt} returns this
 */
proto.feepb.ClearingMarginInt.prototype.setTotalCharge = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string fee_type = 14;
 * @return {string}
 */
proto.feepb.ClearingMarginInt.prototype.getFeeType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingMarginInt} returns this
 */
proto.feepb.ClearingMarginInt.prototype.setFeeType = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional uint32 report_id = 15;
 * @return {number}
 */
proto.feepb.ClearingMarginInt.prototype.getReportId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.feepb.ClearingMarginInt} returns this
 */
proto.feepb.ClearingMarginInt.prototype.setReportId = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional string status = 16;
 * @return {string}
 */
proto.feepb.ClearingMarginInt.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingMarginInt} returns this
 */
proto.feepb.ClearingMarginInt.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string account_no = 17;
 * @return {string}
 */
proto.feepb.ClearingMarginInt.prototype.getAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingMarginInt} returns this
 */
proto.feepb.ClearingMarginInt.prototype.setAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string contra_account_no = 18;
 * @return {string}
 */
proto.feepb.ClearingMarginInt.prototype.getContraAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingMarginInt} returns this
 */
proto.feepb.ClearingMarginInt.prototype.setContraAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string contra_correspondent = 19;
 * @return {string}
 */
proto.feepb.ClearingMarginInt.prototype.getContraCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingMarginInt} returns this
 */
proto.feepb.ClearingMarginInt.prototype.setContraCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.feepb.ListClearingMarginIntRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.feepb.ListClearingMarginIntRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.feepb.ListClearingMarginIntRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.feepb.ListClearingMarginIntRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    correspondent: jspb.Message.getFieldWithDefault(msg, 1, ""),
    branch: jspb.Message.getFieldWithDefault(msg, 2, ""),
    rep: jspb.Message.getFieldWithDefault(msg, 3, ""),
    masterAccountNo: jspb.Message.getFieldWithDefault(msg, 4, ""),
    chargeBy: jspb.Message.getFieldWithDefault(msg, 5, ""),
    month: jspb.Message.getFieldWithDefault(msg, 6, ""),
    year: jspb.Message.getFieldWithDefault(msg, 7, ""),
    feeType: jspb.Message.getFieldWithDefault(msg, 8, ""),
    status: jspb.Message.getFieldWithDefault(msg, 9, ""),
    pagination: (f = msg.getPagination()) && proto_utilspb_pagination_pb.Pagination.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.feepb.ListClearingMarginIntRequest}
 */
proto.feepb.ListClearingMarginIntRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.feepb.ListClearingMarginIntRequest;
  return proto.feepb.ListClearingMarginIntRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.feepb.ListClearingMarginIntRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.feepb.ListClearingMarginIntRequest}
 */
proto.feepb.ListClearingMarginIntRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrespondent(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBranch(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRep(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccountNo(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setChargeBy(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMonth(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setYear(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setFeeType(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 10:
      var value = new proto_utilspb_pagination_pb.Pagination;
      reader.readMessage(value,proto_utilspb_pagination_pb.Pagination.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.feepb.ListClearingMarginIntRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.feepb.ListClearingMarginIntRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.feepb.ListClearingMarginIntRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.feepb.ListClearingMarginIntRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBranch();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRep();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getChargeBy();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMonth();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getYear();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getFeeType();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto_utilspb_pagination_pb.Pagination.serializeBinaryToWriter
    );
  }
};


/**
 * optional string correspondent = 1;
 * @return {string}
 */
proto.feepb.ListClearingMarginIntRequest.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ListClearingMarginIntRequest} returns this
 */
proto.feepb.ListClearingMarginIntRequest.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string branch = 2;
 * @return {string}
 */
proto.feepb.ListClearingMarginIntRequest.prototype.getBranch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ListClearingMarginIntRequest} returns this
 */
proto.feepb.ListClearingMarginIntRequest.prototype.setBranch = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string rep = 3;
 * @return {string}
 */
proto.feepb.ListClearingMarginIntRequest.prototype.getRep = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ListClearingMarginIntRequest} returns this
 */
proto.feepb.ListClearingMarginIntRequest.prototype.setRep = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string master_account_no = 4;
 * @return {string}
 */
proto.feepb.ListClearingMarginIntRequest.prototype.getMasterAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ListClearingMarginIntRequest} returns this
 */
proto.feepb.ListClearingMarginIntRequest.prototype.setMasterAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string charge_by = 5;
 * @return {string}
 */
proto.feepb.ListClearingMarginIntRequest.prototype.getChargeBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ListClearingMarginIntRequest} returns this
 */
proto.feepb.ListClearingMarginIntRequest.prototype.setChargeBy = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string month = 6;
 * @return {string}
 */
proto.feepb.ListClearingMarginIntRequest.prototype.getMonth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ListClearingMarginIntRequest} returns this
 */
proto.feepb.ListClearingMarginIntRequest.prototype.setMonth = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string year = 7;
 * @return {string}
 */
proto.feepb.ListClearingMarginIntRequest.prototype.getYear = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ListClearingMarginIntRequest} returns this
 */
proto.feepb.ListClearingMarginIntRequest.prototype.setYear = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string fee_type = 8;
 * @return {string}
 */
proto.feepb.ListClearingMarginIntRequest.prototype.getFeeType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ListClearingMarginIntRequest} returns this
 */
proto.feepb.ListClearingMarginIntRequest.prototype.setFeeType = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string status = 9;
 * @return {string}
 */
proto.feepb.ListClearingMarginIntRequest.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ListClearingMarginIntRequest} returns this
 */
proto.feepb.ListClearingMarginIntRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional utilspb.Pagination pagination = 10;
 * @return {?proto.utilspb.Pagination}
 */
proto.feepb.ListClearingMarginIntRequest.prototype.getPagination = function() {
  return /** @type{?proto.utilspb.Pagination} */ (
    jspb.Message.getWrapperField(this, proto_utilspb_pagination_pb.Pagination, 10));
};


/**
 * @param {?proto.utilspb.Pagination|undefined} value
 * @return {!proto.feepb.ListClearingMarginIntRequest} returns this
*/
proto.feepb.ListClearingMarginIntRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.feepb.ListClearingMarginIntRequest} returns this
 */
proto.feepb.ListClearingMarginIntRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.feepb.ListClearingMarginIntRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 10) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.feepb.ListClearingMarginIntResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.feepb.ListClearingMarginIntResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.feepb.ListClearingMarginIntResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.feepb.ListClearingMarginIntResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.feepb.ListClearingMarginIntResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    clearingMarginIntsList: jspb.Message.toObjectList(msg.getClearingMarginIntsList(),
    proto.feepb.ClearingMarginInt.toObject, includeInstance),
    summary: (f = msg.getSummary()) && proto.feepb.ListClearingMarginIntSummary.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.feepb.ListClearingMarginIntResponse}
 */
proto.feepb.ListClearingMarginIntResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.feepb.ListClearingMarginIntResponse;
  return proto.feepb.ListClearingMarginIntResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.feepb.ListClearingMarginIntResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.feepb.ListClearingMarginIntResponse}
 */
proto.feepb.ListClearingMarginIntResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.feepb.ClearingMarginInt;
      reader.readMessage(value,proto.feepb.ClearingMarginInt.deserializeBinaryFromReader);
      msg.addClearingMarginInts(value);
      break;
    case 2:
      var value = new proto.feepb.ListClearingMarginIntSummary;
      reader.readMessage(value,proto.feepb.ListClearingMarginIntSummary.deserializeBinaryFromReader);
      msg.setSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.feepb.ListClearingMarginIntResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.feepb.ListClearingMarginIntResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.feepb.ListClearingMarginIntResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.feepb.ListClearingMarginIntResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClearingMarginIntsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.feepb.ClearingMarginInt.serializeBinaryToWriter
    );
  }
  f = message.getSummary();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.feepb.ListClearingMarginIntSummary.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ClearingMarginInt clearing_margin_ints = 1;
 * @return {!Array<!proto.feepb.ClearingMarginInt>}
 */
proto.feepb.ListClearingMarginIntResponse.prototype.getClearingMarginIntsList = function() {
  return /** @type{!Array<!proto.feepb.ClearingMarginInt>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.feepb.ClearingMarginInt, 1));
};


/**
 * @param {!Array<!proto.feepb.ClearingMarginInt>} value
 * @return {!proto.feepb.ListClearingMarginIntResponse} returns this
*/
proto.feepb.ListClearingMarginIntResponse.prototype.setClearingMarginIntsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.feepb.ClearingMarginInt=} opt_value
 * @param {number=} opt_index
 * @return {!proto.feepb.ClearingMarginInt}
 */
proto.feepb.ListClearingMarginIntResponse.prototype.addClearingMarginInts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.feepb.ClearingMarginInt, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.feepb.ListClearingMarginIntResponse} returns this
 */
proto.feepb.ListClearingMarginIntResponse.prototype.clearClearingMarginIntsList = function() {
  return this.setClearingMarginIntsList([]);
};


/**
 * optional ListClearingMarginIntSummary summary = 2;
 * @return {?proto.feepb.ListClearingMarginIntSummary}
 */
proto.feepb.ListClearingMarginIntResponse.prototype.getSummary = function() {
  return /** @type{?proto.feepb.ListClearingMarginIntSummary} */ (
    jspb.Message.getWrapperField(this, proto.feepb.ListClearingMarginIntSummary, 2));
};


/**
 * @param {?proto.feepb.ListClearingMarginIntSummary|undefined} value
 * @return {!proto.feepb.ListClearingMarginIntResponse} returns this
*/
proto.feepb.ListClearingMarginIntResponse.prototype.setSummary = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.feepb.ListClearingMarginIntResponse} returns this
 */
proto.feepb.ListClearingMarginIntResponse.prototype.clearSummary = function() {
  return this.setSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.feepb.ListClearingMarginIntResponse.prototype.hasSummary = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.feepb.ListClearingMarginIntSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.feepb.ListClearingMarginIntSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.feepb.ListClearingMarginIntSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.feepb.ListClearingMarginIntSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    recurringFee: jspb.Message.getFieldWithDefault(msg, 1, ""),
    grossAmt: jspb.Message.getFieldWithDefault(msg, 2, ""),
    minCharge: jspb.Message.getFieldWithDefault(msg, 3, ""),
    totalCharge: jspb.Message.getFieldWithDefault(msg, 4, ""),
    totalRows: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.feepb.ListClearingMarginIntSummary}
 */
proto.feepb.ListClearingMarginIntSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.feepb.ListClearingMarginIntSummary;
  return proto.feepb.ListClearingMarginIntSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.feepb.ListClearingMarginIntSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.feepb.ListClearingMarginIntSummary}
 */
proto.feepb.ListClearingMarginIntSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecurringFee(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setGrossAmt(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMinCharge(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalCharge(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalRows(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.feepb.ListClearingMarginIntSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.feepb.ListClearingMarginIntSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.feepb.ListClearingMarginIntSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.feepb.ListClearingMarginIntSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecurringFee();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGrossAmt();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMinCharge();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTotalCharge();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTotalRows();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
};


/**
 * optional string recurring_fee = 1;
 * @return {string}
 */
proto.feepb.ListClearingMarginIntSummary.prototype.getRecurringFee = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ListClearingMarginIntSummary} returns this
 */
proto.feepb.ListClearingMarginIntSummary.prototype.setRecurringFee = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string gross_amt = 2;
 * @return {string}
 */
proto.feepb.ListClearingMarginIntSummary.prototype.getGrossAmt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ListClearingMarginIntSummary} returns this
 */
proto.feepb.ListClearingMarginIntSummary.prototype.setGrossAmt = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string min_charge = 3;
 * @return {string}
 */
proto.feepb.ListClearingMarginIntSummary.prototype.getMinCharge = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ListClearingMarginIntSummary} returns this
 */
proto.feepb.ListClearingMarginIntSummary.prototype.setMinCharge = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string total_charge = 4;
 * @return {string}
 */
proto.feepb.ListClearingMarginIntSummary.prototype.getTotalCharge = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ListClearingMarginIntSummary} returns this
 */
proto.feepb.ListClearingMarginIntSummary.prototype.setTotalCharge = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 total_rows = 5;
 * @return {number}
 */
proto.feepb.ListClearingMarginIntSummary.prototype.getTotalRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.feepb.ListClearingMarginIntSummary} returns this
 */
proto.feepb.ListClearingMarginIntSummary.prototype.setTotalRows = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.feepb.ClearingFeeDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.feepb.ClearingFeeDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.feepb.ClearingFeeDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.feepb.ClearingFeeDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    correspondent: jspb.Message.getFieldWithDefault(msg, 1, ""),
    branch: jspb.Message.getFieldWithDefault(msg, 2, ""),
    rep: jspb.Message.getFieldWithDefault(msg, 3, ""),
    masterAccountNo: jspb.Message.getFieldWithDefault(msg, 4, ""),
    month: jspb.Message.getFieldWithDefault(msg, 5, ""),
    year: jspb.Message.getFieldWithDefault(msg, 6, ""),
    recurringFee: jspb.Message.getFieldWithDefault(msg, 7, ""),
    qty: jspb.Message.getFieldWithDefault(msg, 8, ""),
    grossAmt: jspb.Message.getFieldWithDefault(msg, 9, ""),
    chargeBy: jspb.Message.getFieldWithDefault(msg, 10, ""),
    minCharge: jspb.Message.getFieldWithDefault(msg, 11, ""),
    rate: jspb.Message.getFieldWithDefault(msg, 12, ""),
    side: jspb.Message.getFieldWithDefault(msg, 13, ""),
    minFee: jspb.Message.getFieldWithDefault(msg, 14, ""),
    accountNo: jspb.Message.getFieldWithDefault(msg, 15, ""),
    contraAccountNo: jspb.Message.getFieldWithDefault(msg, 16, ""),
    contraCorrespondent: jspb.Message.getFieldWithDefault(msg, 17, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 18, ""),
    orderNo: jspb.Message.getFieldWithDefault(msg, 19, ""),
    compressType: jspb.Message.getFieldWithDefault(msg, 20, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.feepb.ClearingFeeDetails}
 */
proto.feepb.ClearingFeeDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.feepb.ClearingFeeDetails;
  return proto.feepb.ClearingFeeDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.feepb.ClearingFeeDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.feepb.ClearingFeeDetails}
 */
proto.feepb.ClearingFeeDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrespondent(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBranch(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRep(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccountNo(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMonth(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setYear(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecurringFee(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setQty(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setGrossAmt(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setChargeBy(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setMinCharge(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setRate(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setSide(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setMinFee(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNo(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setContraAccountNo(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setContraCorrespondent(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderNo(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompressType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.feepb.ClearingFeeDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.feepb.ClearingFeeDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.feepb.ClearingFeeDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.feepb.ClearingFeeDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBranch();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRep();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMonth();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getYear();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getRecurringFee();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getQty();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getGrossAmt();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getChargeBy();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getMinCharge();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getRate();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getSide();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getMinFee();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getContraAccountNo();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getContraCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getOrderNo();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getCompressType();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
};


/**
 * optional string correspondent = 1;
 * @return {string}
 */
proto.feepb.ClearingFeeDetails.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingFeeDetails} returns this
 */
proto.feepb.ClearingFeeDetails.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string branch = 2;
 * @return {string}
 */
proto.feepb.ClearingFeeDetails.prototype.getBranch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingFeeDetails} returns this
 */
proto.feepb.ClearingFeeDetails.prototype.setBranch = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string rep = 3;
 * @return {string}
 */
proto.feepb.ClearingFeeDetails.prototype.getRep = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingFeeDetails} returns this
 */
proto.feepb.ClearingFeeDetails.prototype.setRep = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string master_account_no = 4;
 * @return {string}
 */
proto.feepb.ClearingFeeDetails.prototype.getMasterAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingFeeDetails} returns this
 */
proto.feepb.ClearingFeeDetails.prototype.setMasterAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string month = 5;
 * @return {string}
 */
proto.feepb.ClearingFeeDetails.prototype.getMonth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingFeeDetails} returns this
 */
proto.feepb.ClearingFeeDetails.prototype.setMonth = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string year = 6;
 * @return {string}
 */
proto.feepb.ClearingFeeDetails.prototype.getYear = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingFeeDetails} returns this
 */
proto.feepb.ClearingFeeDetails.prototype.setYear = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string recurring_fee = 7;
 * @return {string}
 */
proto.feepb.ClearingFeeDetails.prototype.getRecurringFee = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingFeeDetails} returns this
 */
proto.feepb.ClearingFeeDetails.prototype.setRecurringFee = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string qty = 8;
 * @return {string}
 */
proto.feepb.ClearingFeeDetails.prototype.getQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingFeeDetails} returns this
 */
proto.feepb.ClearingFeeDetails.prototype.setQty = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string gross_amt = 9;
 * @return {string}
 */
proto.feepb.ClearingFeeDetails.prototype.getGrossAmt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingFeeDetails} returns this
 */
proto.feepb.ClearingFeeDetails.prototype.setGrossAmt = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string charge_by = 10;
 * @return {string}
 */
proto.feepb.ClearingFeeDetails.prototype.getChargeBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingFeeDetails} returns this
 */
proto.feepb.ClearingFeeDetails.prototype.setChargeBy = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string min_charge = 11;
 * @return {string}
 */
proto.feepb.ClearingFeeDetails.prototype.getMinCharge = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingFeeDetails} returns this
 */
proto.feepb.ClearingFeeDetails.prototype.setMinCharge = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string rate = 12;
 * @return {string}
 */
proto.feepb.ClearingFeeDetails.prototype.getRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingFeeDetails} returns this
 */
proto.feepb.ClearingFeeDetails.prototype.setRate = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string side = 13;
 * @return {string}
 */
proto.feepb.ClearingFeeDetails.prototype.getSide = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingFeeDetails} returns this
 */
proto.feepb.ClearingFeeDetails.prototype.setSide = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string min_fee = 14;
 * @return {string}
 */
proto.feepb.ClearingFeeDetails.prototype.getMinFee = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingFeeDetails} returns this
 */
proto.feepb.ClearingFeeDetails.prototype.setMinFee = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string account_no = 15;
 * @return {string}
 */
proto.feepb.ClearingFeeDetails.prototype.getAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingFeeDetails} returns this
 */
proto.feepb.ClearingFeeDetails.prototype.setAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string contra_account_no = 16;
 * @return {string}
 */
proto.feepb.ClearingFeeDetails.prototype.getContraAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingFeeDetails} returns this
 */
proto.feepb.ClearingFeeDetails.prototype.setContraAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string contra_correspondent = 17;
 * @return {string}
 */
proto.feepb.ClearingFeeDetails.prototype.getContraCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingFeeDetails} returns this
 */
proto.feepb.ClearingFeeDetails.prototype.setContraCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string symbol = 18;
 * @return {string}
 */
proto.feepb.ClearingFeeDetails.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingFeeDetails} returns this
 */
proto.feepb.ClearingFeeDetails.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string order_no = 19;
 * @return {string}
 */
proto.feepb.ClearingFeeDetails.prototype.getOrderNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingFeeDetails} returns this
 */
proto.feepb.ClearingFeeDetails.prototype.setOrderNo = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string compress_type = 20;
 * @return {string}
 */
proto.feepb.ClearingFeeDetails.prototype.getCompressType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ClearingFeeDetails} returns this
 */
proto.feepb.ClearingFeeDetails.prototype.setCompressType = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.feepb.ListClearingFeeDetailsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.feepb.ListClearingFeeDetailsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.feepb.ListClearingFeeDetailsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.feepb.ListClearingFeeDetailsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    month: jspb.Message.getFieldWithDefault(msg, 1, ""),
    year: jspb.Message.getFieldWithDefault(msg, 2, ""),
    correspondent: jspb.Message.getFieldWithDefault(msg, 3, ""),
    masterAccountNo: jspb.Message.getFieldWithDefault(msg, 4, ""),
    feeType: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.feepb.ListClearingFeeDetailsRequest}
 */
proto.feepb.ListClearingFeeDetailsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.feepb.ListClearingFeeDetailsRequest;
  return proto.feepb.ListClearingFeeDetailsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.feepb.ListClearingFeeDetailsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.feepb.ListClearingFeeDetailsRequest}
 */
proto.feepb.ListClearingFeeDetailsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMonth(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setYear(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrespondent(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccountNo(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFeeType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.feepb.ListClearingFeeDetailsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.feepb.ListClearingFeeDetailsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.feepb.ListClearingFeeDetailsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.feepb.ListClearingFeeDetailsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMonth();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getYear();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFeeType();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string month = 1;
 * @return {string}
 */
proto.feepb.ListClearingFeeDetailsRequest.prototype.getMonth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ListClearingFeeDetailsRequest} returns this
 */
proto.feepb.ListClearingFeeDetailsRequest.prototype.setMonth = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string year = 2;
 * @return {string}
 */
proto.feepb.ListClearingFeeDetailsRequest.prototype.getYear = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ListClearingFeeDetailsRequest} returns this
 */
proto.feepb.ListClearingFeeDetailsRequest.prototype.setYear = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string correspondent = 3;
 * @return {string}
 */
proto.feepb.ListClearingFeeDetailsRequest.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ListClearingFeeDetailsRequest} returns this
 */
proto.feepb.ListClearingFeeDetailsRequest.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string master_account_no = 4;
 * @return {string}
 */
proto.feepb.ListClearingFeeDetailsRequest.prototype.getMasterAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ListClearingFeeDetailsRequest} returns this
 */
proto.feepb.ListClearingFeeDetailsRequest.prototype.setMasterAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string fee_type = 5;
 * @return {string}
 */
proto.feepb.ListClearingFeeDetailsRequest.prototype.getFeeType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.feepb.ListClearingFeeDetailsRequest} returns this
 */
proto.feepb.ListClearingFeeDetailsRequest.prototype.setFeeType = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.feepb.ListClearingFeeDetailsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.feepb.ListClearingFeeDetailsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.feepb.ListClearingFeeDetailsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.feepb.ListClearingFeeDetailsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.feepb.ListClearingFeeDetailsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    clearingFeeDetailsList: jspb.Message.toObjectList(msg.getClearingFeeDetailsList(),
    proto.feepb.ClearingFeeDetails.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.feepb.ListClearingFeeDetailsResponse}
 */
proto.feepb.ListClearingFeeDetailsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.feepb.ListClearingFeeDetailsResponse;
  return proto.feepb.ListClearingFeeDetailsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.feepb.ListClearingFeeDetailsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.feepb.ListClearingFeeDetailsResponse}
 */
proto.feepb.ListClearingFeeDetailsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.feepb.ClearingFeeDetails;
      reader.readMessage(value,proto.feepb.ClearingFeeDetails.deserializeBinaryFromReader);
      msg.addClearingFeeDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.feepb.ListClearingFeeDetailsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.feepb.ListClearingFeeDetailsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.feepb.ListClearingFeeDetailsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.feepb.ListClearingFeeDetailsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClearingFeeDetailsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.feepb.ClearingFeeDetails.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ClearingFeeDetails clearing_fee_details = 1;
 * @return {!Array<!proto.feepb.ClearingFeeDetails>}
 */
proto.feepb.ListClearingFeeDetailsResponse.prototype.getClearingFeeDetailsList = function() {
  return /** @type{!Array<!proto.feepb.ClearingFeeDetails>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.feepb.ClearingFeeDetails, 1));
};


/**
 * @param {!Array<!proto.feepb.ClearingFeeDetails>} value
 * @return {!proto.feepb.ListClearingFeeDetailsResponse} returns this
*/
proto.feepb.ListClearingFeeDetailsResponse.prototype.setClearingFeeDetailsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.feepb.ClearingFeeDetails=} opt_value
 * @param {number=} opt_index
 * @return {!proto.feepb.ClearingFeeDetails}
 */
proto.feepb.ListClearingFeeDetailsResponse.prototype.addClearingFeeDetails = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.feepb.ClearingFeeDetails, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.feepb.ListClearingFeeDetailsResponse} returns this
 */
proto.feepb.ListClearingFeeDetailsResponse.prototype.clearClearingFeeDetailsList = function() {
  return this.setClearingFeeDetailsList([]);
};


goog.object.extend(exports, proto.feepb);
